import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

export default class Themes {
  constructor(token) {
    const token_bearer = `Bearer ${token.token}`
    const url = `${API_URL}/v1/assets/images`
    axios.defaults.baseURL = url
    axios.defaults.headers.common['Authorization'] = token_bearer
  }

  upload(file, storage = 'theme-background') {
    return axios
      .post(`/${storage}`, file, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .catch((error) => {
        if (!error.response || error.response?.data?.error?.message) {
          return {
            error:
              'Não foi possível processar a sua imagem. Verifique se ela não ultrapassa os 10MB permitidos e tente novamente.',
          }
        }
        return {
          error:
            'Ops! A imagem que você inseriu é maior do que limite máximo permitido (10MB). Verifique a sua imagem e tente novamente.',
        }
      })
  }
}
